import { HereLayer } from '../types';

export const getClusterPresentation = (
  getIcon: HereLayer['getIcon'],
  { clusterWeight, iconsCache, clusterId, position: { lat, lng }, clusterExpansionZoom }: any,
  layerName: string
): H.map.Object | undefined => {
  if (clusterWeight && !!getIcon) {
    // Calculate circle size
    const {
      url,
      height,
      width,
      anchorX,
      anchorY,
      id = ''
    } = getIcon({ clusterWeight, clusterId });

    let clusterIcon = iconsCache[id];

    if (!clusterIcon) {
      clusterIcon = new window.H.map.Icon(url, {
          size: {
            w: width / 2,
            h: height / 2
          },
          anchor: {
            x: anchorX ? anchorX / 2 : 0,
            y: anchorY ? anchorY / 2 : 0,
          }
      });
      iconsCache[id] = clusterIcon;
    }

    var clusterMarker = new window.H.map.Marker(
      { lat, lng },
      {
        icon: clusterIcon,
        // Set min/max zoom with values from the cluster, otherwise
        // clusters will be shown at all zoom levels
        // min: cluster.getMinZoom(), // 0 - min value
        // max: cluster.getMaxZoom(), // 22 - max value
        min: 0,
        max: 22,
        zIndex: 10,
        data: {
          type: 'cluster',
          clusterExpansionZoom,
          layerName
        }
    });

    return clusterMarker;
  }

  return undefined;
}